export const isVerticalLink = (obj) => {
    return typeof obj === 'object' && !!obj && 'verticalKey' in obj;
};
//# sourceMappingURL=verticalLink.js.map